let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("akTOz")).then(() => parcelRequire('2HXHP'));